import React from 'react';
import InProgress from 'common/InProgress/InProgress';
import useGetDealerSettings from 'common/hooks/useGetDealerSettings';
import useConfirmNewEmail, { ConfirmNewEmailStatus } from './useConfirmNewEmail';
import ConfirmNewEmailSuccess from './ConfirmNewEmailSuccess';
import ConfirmNewEmailError from './ConfirmNewEmailError';
import ConfirmNewEmailInvalidSecret from './ConfirmNewEmailInvalidSecret';

const ConfirmNewEmail = () => {
  const { status, confirmNewEmail } = useConfirmNewEmail();

  const {
    dealerSettings: { phone: supportPhoneNumber },
  } = useGetDealerSettings();

  switch (status) {
    case ConfirmNewEmailStatus.Completed:
      return <ConfirmNewEmailSuccess />;
    case ConfirmNewEmailStatus.Error:
      return <ConfirmNewEmailError confirmNewEmail={confirmNewEmail} supportPhoneNumber={supportPhoneNumber} />;
    case ConfirmNewEmailStatus.InvalidSecret:
      return <ConfirmNewEmailInvalidSecret supportPhoneNumber={supportPhoneNumber} />;
    case ConfirmNewEmailStatus.InProgress:
    default:
      return <InProgress />;
  }
};

export default ConfirmNewEmail;
